import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import { CELL_VERTICAL_ALIGNS, cellVerticalAlign, type CellVerticalAlign } from '@blogaris/shared';

/**
 * เพิ่มการจัดแนวตั้งให้เซลล์ตาราง (ชิดบน / กึ่งกลาง / ชิดล่าง)
 *
 * TipTap ไม่มีมาให้ เพราะ prosemirror-tables สนใจแค่โครงสร้างตาราง ไม่ยุ่งกับการจัดหน้า
 * เก็บเป็น attribute ของเซลล์ ไม่ใช่ของย่อหน้าข้างใน เพราะเซลล์หนึ่งมีหลายย่อหน้าได้
 * และการจัดแนวตั้งเป็นเรื่องของ "ช่อง" ไม่ใช่ของข้อความ
 */
function verticalAlignAttribute() {
  return {
    verticalAlign: {
      default: null as CellVerticalAlign | null,
      parseHTML: (el: HTMLElement) => {
        const v = cellVerticalAlign(el.style?.verticalAlign);
        return v === 'top' ? null : v;
      },
      renderHTML: (attrs: Record<string, unknown>) => {
        const v = attrs.verticalAlign;
        // ชิดบนเป็นค่าเริ่มต้นอยู่แล้วตาม CSS ไม่ต้องเขียนซ้ำลง DOM
        return typeof v === 'string' && v !== 'top' && CELL_VERTICAL_ALIGNS.includes(v as CellVerticalAlign)
          ? { style: `vertical-align:${v}` }
          : {};
      },
    },
  };
}

export const AlignedTableCell = TableCell.extend({
  addAttributes() {
    return { ...this.parent?.(), ...verticalAlignAttribute() };
  },
});

export const AlignedTableHeader = TableHeader.extend({
  addAttributes() {
    return { ...this.parent?.(), ...verticalAlignAttribute() };
  },
});
